import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


// IMPORT GUARD FILES

import { AuthGuard } from './../../auth.guard';
import { ModuleGuard } from './../../permission.guard';
import { Role } from './../../_models/role';
import { Permission } from './../../_models/permission';

// IMPORT STAFF MODULE COMPONENTS
import { MainStaffComponent } from './main-staff.component';
import { StaffComponent } from '../staff.component';
import { SingleStaffComponent } from '../single-staff/single-staff.component';


const routes: Routes = [
  {
    path: '',
    component: MainStaffComponent,
    children: [
      {
        path: 'list',
        component: StaffComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Admin, Role.Manager], permission: [Permission.Staff] }
      },
      {
        path: 'view/:id',
        component: SingleStaffComponent,
        canActivate: [AuthGuard],
      },
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainStaffRoutingModule { }
